// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__1N-Tc","ranges":"BmiRanges_ranges__IJjNM"};